import React, {Component} from 'react';
import {withLocalize} from 'react-localize-redux';

class TranslationViewer extends Component {
	
	render() {
		let value;
		if (typeof this.props.value === 'string')
			value = JSON.parse(this.props.value);
		else
			value = this.props.value;
		
		return (
			<div>
				{(value && this.props.activeLanguage && value[this.props.activeLanguage.code])}
			</div>
		);
	}
}

export default withLocalize(TranslationViewer);


// WEBPACK FOOTER //
// ./src/03-components/TranslationViewer/index.js